export default __webpack_public_path__ + "static/media/scale-circle.316f6e4b.less";